import { render, staticRenderFns } from "./RoyaltyIncentive.vue?vue&type=template&id=1b81cee2&"
import script from "./RoyaltyIncentive.vue?vue&type=script&lang=js&"
export * from "./RoyaltyIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports